import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
  currentUserAvator: null,
  showSubBanner: "N",
  expandMainMenu: true,
  loading: false,
  error: false,
  sessionValidated: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
    },
    loginSuccess: (state, action) => {
      // console.log(`loginSuccess ${JSON.stringify(action.payload, null, 2)}`)
      state.loading = false;
      state.currentUser = action.payload;
      state.sessionValidated = true;
      state.expandMainMenu = true;
      if (action.payload?.subscription_status_xx === 'grace_period' && action.payload?.user_type_xx === 'superadmin') {
        state.showSubBanner = "Y";
      } else {
        state.showSubBanner = "N";
      }
    },
    loginFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    logOut: (state) => {
      state.currentUser = null;
      state.loading = false;
      state.error = false;
    },
    showBanner: (state, action) => {
      state.showSubBanner = action.payload;
    },
    setAvator: (state, action) => {
      state.currentUserAvator = action.payload;
    },
    setExpandMainMenu: (state, action) => {
      state.expandMainMenu = action.payload;
    },
    setSessionValidated: (state, action) => {
      state.sessionValidated = action.payload;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logOut, showBanner, setAvator, setExpandMainMenu, setSessionValidated } =
  userSlice.actions;

export default userSlice.reducer;